module.exports = __webpack_public_path__ + "images/0b7ec76f10156059046b59588ff64028.svg";